import * as t from 'io-ts';

export const ApiPermissionsSpec = t.array(t.string);

export type ApiPermissions = t.TypeOf<typeof ApiPermissionsSpec>;
